import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import axiosClient from "../../api/axiosClient";
import CreatePasswordForm from "../../components/createPasswordForm/CreatePasswordForm";
import Success from "../../components/success/Success";
import Error from "../../components/Error/Error";
import Loading from "../../components/loading/Loading";
import LoadingOverlay from "../../components/loadingOverlay/LoadingOverlay";
import { useAuth } from "../../contexts/AuthContext";

const ResetPassword = () => {
  const {isAuthenticated, doLogout} = useAuth();
  const [view, setView] = useState('loading');
  const [tokenError, setTokenError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { resetToken } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      await axiosClient.get(`auth/reset-password/${resetToken}`)
      .then (() => {
        setView('reset');
      })
      .catch((error) => {
        setTokenError(error.message);
        setView('error');
      });
    };

    fetchData();
  }, [resetToken]);

  const handlePassword = async (password) => {
    setIsLoading(true);
    await axiosClient.post(`auth/reset-password/${resetToken}`, {
      password,
    })
    .then((data) => {
      setSuccessMessage(data.message);
      setView('success');
      if(isAuthenticated) {
        doLogout();
      }
    })
    .catch((error) => {
      setError(error.message);
    })
    .finally(() => {
      setIsLoading(false);
    });
  }

  switch (view) {
    case 'loading': 
      return (
        <Loading />
      );
    case 'reset' :
      return (
        <>
          {isLoading && <LoadingOverlay />}
          <CreatePasswordForm
            onSubmit={handlePassword}
            error={error}
          />
        </>
      );
    case 'success' :
      return (
        <Success message={successMessage} />
      );
    case 'error' :
      return (
        <Error message={tokenError} />
      );
    default : return <Navigate to="/login" />
  }
};

export default ResetPassword;